import { StreamLanguage, type StringStream } from "@codemirror/language";

interface LaTeXState {
  inMathBlock: boolean;
  inMathInline: boolean;
  inVerbatim: boolean;
}

function tokenize(stream: StringStream, state: LaTeXState): string | null {
  if (state.inVerbatim) {
    if (stream.match(/\\end\{verbatim\}/)) {
      state.inVerbatim = false;
      return "meta";
    }
    stream.next();
    return "string";
  }

  if (state.inMathBlock) {
    if (stream.match("$$")) {
      state.inMathBlock = false;
      return "atom";
    }
    if (stream.match(/\\[a-zA-Z]+/)) return "keyword";
    if (stream.match(/[0-9]+(\.[0-9]+)?/)) return "number";
    if (stream.match(/[{}]/)) return "bracket";
    stream.next();
    return "atom";
  }

  if (state.inMathInline) {
    if (stream.eat("$")) {
      state.inMathInline = false;
      return "atom";
    }
    if (stream.match(/\\[a-zA-Z]+/)) return "keyword";
    if (stream.match(/[0-9]+(\.[0-9]+)?/)) return "number";
    if (stream.match(/[{}]/)) return "bracket";
    stream.next();
    return "atom";
  }

  if (stream.match("$$")) {
    state.inMathBlock = true;
    return "atom";
  }

  if (stream.peek() === "%" && !stream.match(/^\\%/)) {
    stream.skipToEnd();
    return "comment";
  }

  if (stream.match(/\\begin\{verbatim\}/)) {
    state.inVerbatim = true;
    return "meta";
  }

  if (stream.match(/\\(begin|end)\{[^}]*\}/)) return "meta";

  if (stream.match(/\\[a-zA-Z@]+\*?/)) return "keyword";

  if (stream.match(/\\[^a-zA-Z]/)) return "atom";

  if (stream.eat("$")) {
    state.inMathInline = true;
    return "atom";
  }

  if (stream.match(/[{}]/)) return "bracket";
  if (stream.match(/[\[\]]/)) return "bracket";

  if (stream.match(/[0-9]+(\.[0-9]+)?/)) return "number";

  stream.next();
  return null;
}

const latexStreamParser = {
  name: "latex",
  startState(): LaTeXState {
    return { inMathBlock: false, inMathInline: false, inVerbatim: false };
  },
  token: tokenize,
  languageData: {
    commentTokens: { line: "%" },
    closeBrackets: { brackets: ["(", "[", "{", "$"] },
  },
};

export const latexLanguage = StreamLanguage.define(latexStreamParser);
